import { ExtendedProjectInfoDc, ServiceInfoDc, TableInfoDc, LayersWithDeps, ProjectsWithDeps } from "@evergis/api";

import { ResourceInfoDc } from "../../../modules/Catalog/types";

export type DeleteResources = ProjectsWithDeps | LayersWithDeps | TableInfoDc[];

export interface ResourcesResolved {
  projects: ExtendedProjectInfoDc[];
  layers: ServiceInfoDc[];
  tables: TableInfoDc[];
}

const defaultResources = {
  projects: [],
  layers: [],
  tables: [],
};

const byOwner = (owner: string) => (resource: ResourceInfoDc) => resource?.owner?.startsWith(owner);

const resolveDeps = (resources: ResourceInfoDc[], owner: string): ResourceInfoDc[] => {
  return resources ? resources.filter(byOwner(owner)) : [];
};

export function isProjectsWithDeps(res: DeleteResources): res is ProjectsWithDeps {
  return !!res && !Array.isArray(res) && "projects" in res;
}

export function isLayersWithDeps(res: DeleteResources): res is LayersWithDeps {
  return !!res && !Array.isArray(res) && "layers" in res;
}

export function resolveResources(resources: DeleteResources, owner: string): ResourcesResolved {
  if (!resources) {
    return defaultResources;
  }

  if (isProjectsWithDeps(resources)) {
    return {
      projects: resources.projects,
      layers: resolveDeps(resources.deps.layers, owner) as ServiceInfoDc[],
      tables: resolveDeps(resources.deps.tables, owner) as TableInfoDc[],
    };
  }

  if (isLayersWithDeps(resources)) {
    return {
      ...defaultResources,
      layers: resources.layers,
      tables: resolveDeps(resources.deps.tables, owner) as TableInfoDc[],
    };
  }

  return {
    ...defaultResources,
    tables: resources,
  };
}
